export default __webpack_public_path__ + "static/media/rene.50df6554.jpeg";